import React, { Component, Fragment } from "react";
import TestCenter from "./TestCenter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getTestCenters } from "../../actions/testcenterActions";
import TCForm from "./TCForm";
import TCFilter from "./TCFilter";

class TestCenters extends Component {
  componentDidMount() {
    this.props.getTestCenters();
  }

  render() {
    const { testcenters } = this.props;
    const tcPermanent = [];
    const tcPopUp = [];
    for (var x = 0; x < testcenters.length; x++) {
      if (testcenters[x].permanentLocation === true) {
        tcPermanent.push(testcenters[x]);
      } else {
        tcPopUp.push(testcenters[x]);
      }
    }
    const count = testcenters.length;
    return (
      <Fragment>
        <TCForm />
        <TCFilter />
        <h4 className="my-4 ">COVID-19 Test Centers</h4>
        <p>There are {count} Test Centers Near You</p>
        {tcPermanent.length > 0 ? (
          <h4 className="my-4">Regional Public Testing Locations</h4>
        ) : null}
        {tcPermanent.reverse().map((testcenter) => (
          <TestCenter key={testcenter._id} testcenter={testcenter} />
        ))}
        {tcPopUp.length > 0 ? (
          <h4 className="my-4">Pop-Up Events Locations</h4>
        ) : null}
        {tcPopUp.reverse().map((testcenter) => (
          <TestCenter key={testcenter._id} testcenter={testcenter} />
        ))}
        {count < 10 ? (
          <a className="btn btn-primary btn-block my-4" href="/">
            Show All
          </a>
        ) : null}
      </Fragment>
    );
  }
}
TestCenters.propTypes = {
  testcenters: PropTypes.array.isRequired,
  getTestCenters: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  testcenters: state.testcenter.testcenters,
});

export default connect(mapStateToProps, {
  getTestCenters,
})(TestCenters);
